import React from "react";
import { motion } from "framer-motion";
import { useNavigate } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { FaStar, FaMapMarkerAlt } from "react-icons/fa";
import "./horizontalhotelcard.css";
import { resolveImageUrl } from "../../constants";

export default function HorizontalHotelCard({ property }) {
  const navigate = useNavigate();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === 'ar';

  // Get first image or use placeholder
  const firstImage = property.images?.[0]?.url
    ? resolveImageUrl(property.images[0].url)
    : '/placeholder-hotel.jpg';

  // Animation variants
  const cardVariants = {
    hidden: { opacity: 0, y: 20 },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.5,
        ease: "easeOut"
      }
    },
    hover: {
      scale: 1.02,
      boxShadow: "0 10px 25px rgba(0, 0, 0, 0.15)",
      transition: {
        duration: 0.3
      }
    }
  };

  return (
    <motion.div
      className={`horizontal-hotel-card ${isRTL ? 'rtl' : ''}`}
      variants={cardVariants}
      initial="hidden"
      animate="visible"
      whileHover="hover"
      onClick={() => navigate(`/hotel-one/${property.code}`)}
    >
      <div className="card-image-container">
        <img 
          src={firstImage} 
          alt={property.name} 
          className="card-img"
          loading="lazy"
        />
        <div className="card-rating">
          <FaStar className="star-icon" />
          <span>4.8</span>
        </div>
      </div>
      
      <div className="card-content">
        <div className="card-info">
          <div className="card-header">
            <h3 className="card-title">
              {isRTL && property.name_ar ? property.name_ar : property.name}
            </h3>
            <div className="card-location">
              <FaMapMarkerAlt className="location-icon" />
              <span>{property.location}</span>
            </div>
          </div>
          
          <p className="card-description" dir={isRTL ? 'rtl' : 'ltr'}>
            {isRTL && property.description_ar ? property.description_ar : property.description}
          </p>
          
          {(() => {
            const services = Array.isArray(property.services) ? property.services
              : typeof property.services === 'string' ? (() => { try { const p = JSON.parse(property.services); return Array.isArray(p) ? p.map(s => typeof s === 'string' ? s : s.name || String(s)) : []; } catch { return []; } })()
              : [];
            return services.length > 0 ? (
              <div className="card-services">
                <h4>{t('horizontalhotelcard.servicesTitle')}</h4>
                <div className="services-container">
                  {services.map((service, index) => (
                    <span key={index} className="service-tag">
                      {service}
                    </span>
                  ))}
                </div>
              </div>
            ) : null;
          })()}
        </div>
        
        <div className="card-booking">
          <div className="price-container">
            <span className="price-from">{t('horizontalhotelcard.from')}</span>
            <div className="price-value">
              {property.startprice ? Number(property.startprice).toLocaleString() : '10,000'}
              <span className="price-unit">{t('horizontalhotelcard.priceUnit')}</span>
            </div>
            <span className="price-note">{t('horizontalhotelcard.perNight')}</span>
          </div>
          
          <button 
            className="reserve-button"
            onClick={(e) => {
              e.stopPropagation();
              navigate(`/hotel-one/${property.code}`);
            }}
          >
            {t('horizontalhotelcard.bookNow')}
          </button>
        </div>
      </div>
    </motion.div>
  );
}